<template>
    <div style="overflow: hidden;width: 100%">
        <div class="footer text-center pt-5 pb-5 size1 mt-6" style="background: #3a3a3a">
<!--            <p class="mb-0">广东省环境监测中心阳光快采平台</p>-->
<!--            <p class="mb-0 color-white">Copyright c2020 广东志正招标有限公司 All Rights Reserved 粤ICP备 12345678号</p>-->
            <p class="mb-0 color-white">Copyright © 2020 广东志正招标有限公司,All Rights Reserved 粤ICP备09106293号</p>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
        },
        mounted() {
        },
        data() {
            return {
                userName: '',
                orgName: '',
                actions: [
                    {type: 'bank', text: '广东省环境监测中心'},
                    {type: 'clock-circle', text: '发布时间：今天10: 30 '},
                ]
            }
        },
        methods: {
        }
    }
</script>
<style lang="less" scoped>
    .main-nav a{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 20px;
        background: rgba(255, 255, 255, 0.3);
        margin-right: 2px;
        height: 76px;
    }
    .main-nav a b{
        color: #fff;
        font-weight: 500;
        margin-left: 10px;
    }
    .main-nav a .icon:nth-child(1){
        display: none;
    }
    .main-nav .active{
        background: #f9f9f9;
    }
    .main-nav .active .icon:nth-child(1){
        display: block;
    }
    .main-nav .active .icon:nth-child(2){
        display:none;
    }
    .main-nav .active b{
        color: inherit;
    }
    .main-nav a:hover{
        background: #f9f9f9;
    }
    .main-nav a:hover b{
        color: inherit;
    }
    .main-nav a:hover .icon:nth-child(1){
        display: block;
    }
    .main-nav a:hover .icon:nth-child(2){
        display:none;
    }
    .icon {
        width: 36px;
        height: 36px;
        vertical-align: -0.15em;
        fill: currentColor;
        overflow: hidden;
        line-height: 30px;
        display: block;
    }

    .index-bg {
        position: relative;
        width: 1920px;
        left: 50%;
        margin-left: -960px;
    }

    .index-info {
        display: flex;
        align-items: center;
        color: #fff;
    }

    .index-info img {
        display: block;
    }

    .index-info p {
        margin: 0;
    }

    .shadow {
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
        border-radius: 6px;
    }

    .shadow:hover {
        background: #f1f9ff;
    }

    /deep/ .ant-tabs-nav .ant-tabs-tab {
        font-size: 20px;
        font-weight: bold;
    }

    /deep/ .ant-tabs-ink-bar {
        bottom: 1px;
        height: 3px;
    }

    /deep/ .ant-list-item-action li {
        padding: 0 30px;
        display: flex;
        align-items: center;
        cursor: auto;
        min-height: 74px;
    }

    /deep/ .ant-list-item-action-split {
        margin-top: 0;
        height: 100%;
        top: 0;
    }

    /deep/ .ant-list-item-action {
        display: flex;
    }

    /deep/ .ant-list-item-meta-title > a {
        font-size: 20px;
    }

    /deep/ .ant-list-item-extra-wrap {
        width: 100%;
        min-height: 74px;
    }

    /deep/ .ant-list-item-extra {
        margin-top: -30px;
        margin-bottom: 0;
    }

    /deep/ .ant-list-item-extra span {
        margin-right: 40px;
    }

    /deep/ .ant-list-item-meta-title {
        margin-top: 8px;
        color: #262626;
        font-weight: bold;
    }

    /deep/ .ant-list-item-meta-title a:hover {
        color: rgb(24, 144, 255) !important;
    }

    /deep/ .ant-list-item {
        position: relative;
        padding: 20px 0 20px 20px;
        background: #fff;
    }

    /deep/ .ant-tabs-bar {
        margin-bottom: 0;
        border-bottom: 3px solid #e6e6e6;
    }
</style>
